(function () {
  function initCountup(root) {
    const section = (root || document).querySelector(".countup-spec-section");
    if (!section) return;

    const counters = section.querySelectorAll(".spec-number");
    if (!counters.length) return;

    let triggered = false;

    function animateCounter(counter) {
      const valueEl = counter.querySelector(".spec-value");
      const unitEl = counter.querySelector(".spec-unit");

      if (!valueEl) return;

      const targetRaw = counter.dataset.count ?? "0";
      const target = parseFloat(targetRaw);
      const duration = parseInt(counter.dataset.duration, 10) || 1500;
      const suffix = counter.dataset.suffix || "";

      // 小数桁数を data-count から推定（例: 99.9 → 1桁）
      const decimals = (targetRaw.split(".")[1] || "").length;

      unitEl.textContent = suffix;

      const startTime = performance.now();
      const startValue = 0;

      function tick(now) {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // easeOutQuad（自然に減速）
        const eased = 1 - (1 - progress) * (1 - progress);
        const current = startValue + (target - startValue) * eased;

        valueEl.textContent = decimals ? current.toFixed(decimals) : String(Math.floor(current));

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          // 最終値を確定（誤差潰し）
          valueEl.textContent = decimals ? target.toFixed(decimals) : String(Math.floor(target));
        }
      }

      requestAnimationFrame(tick);
    }

    function run() {
      if (triggered) return;
      triggered = true;
      counters.forEach(animateCounter);
    }

    // IntersectionObserver 優先（スクロール判定より確実）
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              run();
              io.disconnect();
            }
          });
        },
        { root: null, threshold: 0.25 }
      );
      io.observe(section);
    } else {
      // フォールバック（古いブラウザ）
      function handleScroll() {
        const rect = section.getBoundingClientRect();
        if (!triggered && rect.top < window.innerHeight * 0.85) run();
      }
      window.addEventListener("scroll", handleScroll, { passive: true });
      handleScroll();
    }
  }

  // 通常ロード
  document.addEventListener("DOMContentLoaded", function () {
    initCountup(document);
  });

  // Shopifyテーマエディタでの再描画対策
  document.addEventListener("shopify:section:load", function (e) {
    initCountup(e.target);
  });
})();
